<template>
    <listings-find
        v-slot="{
            data: listing,
            error: find_error,
            has_loaded,
            find
        }"
        :params="{ listing: $route.params.listing }"
        :include="['property,files(filters:with_erased=false)']"
    >
        <template v-if="!has_loaded || find_error">
            <div>
                <base-loading
                    :error="find_error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error"
                    :error="find_error"
                />
            </div>
        </template>

        <template v-else>
            <listings-update
                v-slot="{
                    sid,
                    error: update_error,
                    is_loading: is_saving,
                    update
                }"
                :uuid="listing.uuid"
                @success="onListingsUpdateSuccess"
                @error="onListingsUpdateError"
            >
                <div>
                    <listing-form
                        :listing="listing"
                        :sid="sid"
                        :is-loading="is_saving"
                        @submit="update"
                    />

                    <error-modal
                        v-if="update_error && $error.is(update_error, { exclude: [422] })"
                        :error="update_error"
                    />

                    <modal-success
                        :is-open="show_updated_modal"
                        @close="show_updated_modal = false"
                    >
                        <template slot="heading">Listing Updated!</template>

                        <p>Your property listing has been updated!</p>

                        <template v-slot:footer="{ close }">
                            <div class="flex flex-col md:flex-row-reverse">
                                <router-link
                                    v-if="listing"
                                    :to="{
                                        name: 'dashboard.landlords.listings.show',
                                        params: {
                                            listing: listing.uuid
                                        }
                                    }"
                                    class="text-center btn btn-green"
                                >
                                    Go to Listing
                                </router-link>

                                <button
                                    type="button"
                                    @click.prevent="close"
                                    class="mt-3 text-center btn md:mt-0 md:mr-3"
                                >
                                    Close
                                </button>
                            </div>
                        </template>
                    </modal-success>
                </div>
            </listings-update>
        </template>
    </listings-find>
</template>

<script>
    import scroll from '../../../../support/scroll'
    import ListingForm from './_/listing-form'
    import ListingsFind from '../../../../components/listings-find'
    import ListingsUpdate from '../../../../components/listings-update'

    export default {
        components: {
            ListingForm,
            ListingsFind,
            ListingsUpdate
        },
        data () {
            return {
                show_updated_modal: false
            }
        },
        methods: {
            onListingsUpdateSuccess () {
                setTimeout(() => {
                    this.show_updated_modal = true
                }, 0)
            },
            onListingsUpdateError () {
                scroll.toTop()
            }
        }
    }
</script>
